import React from "react";
import { Star } from "lucide-react";
import AdminCrudPage from "./AdminCrudPage";
import { apiGet, apiPost, apiPut } from "./adminApi";

const SECTORS = [
  "AVIATION", "CONSTRUCTION", "HEALTH", "BUSINESS", "ICT", "ARTS", "SCIENCE", "LAW", "EDUCATION",
  "AGRICULTURE", "NUCLEAR_SCIENCE_AND_TECHNOLOGY", "INFRASTRUCTURE", "SPORT", "MINING", "TOURISM",
  "ENVIRONMENTAL", "UN_MENTIONED",
];
const LEVELS = ["HIGH", "MEDIUM", "LOW"];

const pretty = (s) => (s ? s.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase()) : "—");

const sectorOptions = SECTORS.map((s) => ({ value: s, label: pretty(s) }));
const levelOptions = LEVELS.map((l) => ({ value: l, label: pretty(l) }));

const fields = [
  { name: "courseName", label: "Course Name", type: "text", required: true, placeholder: "e.g. Aerospace Engineering", fullWidth: true },
  { name: "courseSector", label: "Course Sector", type: "select", required: true, options: sectorOptions },
  { name: "priorityLevel", label: "Priority Level", type: "select", required: true, options: levelOptions },
];

const levelTone = {
  HIGH: "bg-red-50 text-red-700 border-red-200",
  MEDIUM: "bg-amber-50 text-amber-700 border-amber-200",
  LOW: "bg-gray-100 text-gray-600 border-gray-200",
};

export default function PriorityCoursesPage() {
  return (
    <AdminCrudPage
      title="Priority Courses"
      subtitle="National priority courses and sectors used when assessing abroad scholarship applications"
      icon={Star}
      entityName="priority course"
      queryKey="adminPriorityCourses"
      fetchAll={() => apiGet("hec/priority-course/all")}
      createItem={(values) => apiPost("hec/priority-course/save", values)}
      updateItem={(id, values) => apiPut(`hec/priority-course/${id}`, values)}
      searchKeys={["courseName", "courseSector", "priorityLevel"]}
      columns={[
        { key: "courseName", label: "Course", render: (r) => <span className="font-semibold text-gray-900">{r.courseName}</span> },
        { key: "courseSector", label: "Sector", render: (r) => pretty(r.courseSector) },
        {
          key: "priorityLevel",
          label: "Priority",
          render: (r) => (
            <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${levelTone[r.priorityLevel] || levelTone.LOW}`}>
              {pretty(r.priorityLevel)}
            </span>
          ),
        },
      ]}
      fields={fields}
      filters={[
        { name: "sector", label: "Sectors", options: sectorOptions, match: (row, v) => row.courseSector === v },
        { name: "level", label: "Priority Levels", options: levelOptions, match: (row, v) => row.priorityLevel === v },
      ]}
    />
  );
}
